export default __webpack_public_path__ + "static/media/bg.eeb3e58f.png";